import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './new-event.css';
import { Label, Input } from "reactstrap"
import TableEventsCode from "../../../components/table-events-code/TableEventsCode";
//Redux
import { setOldState, editEvents } from "../../../redux/actions";
import { connect } from "react-redux";
import Redirect from "../../../routes/Redirect";


class NewEvent extends React.Component {
    eventMain = {
        id: "",
        name: "",
        eventType: "",
        code: "",
        hardware: "",
        weight: "",
        active: true,
        isGood: false,
        isRuler: false
    }

    constructor(props) {
        super(props)

        this.codeInput = React.createRef();

        this.state = {
            loadingType: false,
            loadingHardware: false,
            loadingGetEvents: false,
            loading: false,
            toast: [],
            redirect: false,
            eventsType: [],
            hardsType: [],
            eventMain: this.eventMain,
            alert: { msg: '', type: '' },
        }
    }




    componentDidMount = () => {
        this.getEventsType()
        this.getHardsType()
        if (this.props.editEventData) {
            console.log('Edit:', this.props.editEventData.id)
            this.setState({ loadingGetEvents: true })
            // this.setState({ eventMain: this.props.editEventData })
            this.getEvent(this.props.editEventData.id)
        }

    }

    getEvent = (id) => {
        this.setState({ loadingGetEvents: true })
        axios
            .get(
                `${url}/v1/telemetria/backoffice/events/${id}/${this.props.token
                }`
            )
            .then(d => {
                console.log('do banco', d.data)
                setTimeout(() => {
                    this.setState({ eventMain: d.data, loadingGetEvents: false })
                }, 200);
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })

            });
    }

    getEventsType = () => {
        this.setState({ loadingType: true })
        axios
            .get(
                `${url}/v1/telemetria/backoffice/events/listTypes/${this.props.token
                }`
            )
            .then(d => {
                let options = [];
                for (let i = 0; i < d.data.length; i++) {
                    options.push({
                        value: d.data[i],
                        label: d.data[i]
                    });
                }
                this.setState({ eventsType: options, loadingType: false });
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })

            });
    }

    getHardsType = () => {
        this.setState({ loadingHardware: true })

        axios
            .get(
                `${url}/v1/telemetria/backoffice/listHardwares/${this.props.token
                }`
            )
            .then(d => {
                let options = [];
                for (let i = 0; i < d.data.length; i++) {
                    options.push({
                        value: d.data[i],
                        label: d.data[i]
                    });
                }
                this.setState({ hardsType: options, loadingHardware: false });
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })

            });
    }

    checkEventCode = () => {
        console.log(this.state.eventMain.code)
        axios
            .get(
                `${url}/v1/telemetria/backoffice/events/checkEventCode/${this.state.eventMain.code}/${this.props.token
                }`
            )
            .then(d => {
                console.log(d.data)
                if (!d.data.first) {
                    store.addNotification({ ...this.props.bodyNotify, title: d.data.second, type: 'danger' });
                    this.codeInput.current.focus();
                    this.codeInput.current.select();

                }
            })
            .catch(e => {
                console.log(e.response)
                if (e.response.data.errorMessage) {
                    e.response.data.errorMessage.forEach(d => {
                        store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                    });
                    this.codeInput.current.focus();
                    this.codeInput.current.select();
                }
            });
    }

    handleEventsType = i => {
        console.log(i)
        var eventMain = this.state.eventMain
        if (!i) {
            eventMain.eventType = ""
            this.setState({ eventMain })
            return;
        }
        eventMain.eventType = i.value;
        this.setState({ eventMain })
    };

    handleHardsType = i => {
        console.log(i)
        var eventMain = this.state.eventMain
        if (!i) {
            eventMain.hardware = ""
            this.setState({ eventMain })
            return;
        }
        eventMain.hardware = i.value;
        this.setState({ eventMain })
    };

    //No option selects
    noOptionsMessage = (e, sel) => {
        if (e.inputValue === "") {
            return sel === "eventType"
                ? "Pesquise os tipos de eventos!"
                : sel === "license"
                    ? "Pesquise as frotas!"
                    : sel === "failure" ? "Pesquise falhas"
                        : null;
        } else {
            return `${e.inputValue}: não foi encontrado!`;
        }
    };

    saveEvent = (listHardwareCodes) => {
        if (this.validFilds()) {
            console.log(this.state.eventMain)
            axios
                .post(`${url}/v1/telemetria/backoffice/events/save/${this.props.token}`, { ...this.state.eventMain, listHardwareCodes })
                .then(d => {
                    console.log(d)
                    this.setState({ loading: false, eventMain: this.eventMain, loadingHardware: true })
                    if (this.props.editEventData) {
                        this.backPage(d.data.name, true)
                    } else {
                        store.addNotification({ ...this.props.bodyNotify, title: `Evento: ${d.data.name} Salvo!`, type: 'success' });
                        setTimeout(() => {
                            this.setState({ loading: false, eventMain: this.eventMain, loadingHardware: false })
                        }, 200);

                    }

                }).catch(e => {
                    console.log(e.response)
                    var errorMsg = e.response.data.errorMessage
                    this.setState({ loading: false })
                    errorMsg.forEach(d => {
                        if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                        else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                    })
                })

        } else {
            return
        }
    }

    validFilds = () => {
        if (!this.state.eventMain.name.length) {
            store.addNotification({ ...this.props.bodyNotify, title: 'Nome é obrigatório!', type: 'danger' });
            return false
        } else if (!this.state.eventMain.code.length) {
            store.addNotification({ ...this.props.bodyNotify, title: 'Código do evento é obrigatório!', type: 'danger' });
            return false
        } else if (!this.state.eventMain.weight) {
            store.addNotification({ ...this.props.bodyNotify, title: 'Peso do evento é obrigatório!', type: 'danger' });
            return false
        } else if (!this.state.eventMain.eventType) {
            store.addNotification({ ...this.props.bodyNotify, title: 'Tipo do evento é obrigatório!', type: 'danger' });
            return false
        } else if (!this.state.eventMain.hardware) {
            store.addNotification({ ...this.props.bodyNotify, title: 'Hardware é obrigatório!', type: 'danger' });
            return false
        } else {
            return true
        }
    }

    backPage = (name, edit) => {
        setTimeout(() => {
            this.props.setOldState({ ...this.props.oldStateFilter, name, edit })
            this.props.editEvents(undefined, undefined)
            this.setState({ redirect: true })
        }, 500);
    }



    renderToolbar = () => {
        return (
            <ToolBar>
                <div style={{ height: '65px' }}>
                </div>

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}
                <Redirect to={'/admin/events'} redirect={this.state.redirect} />

                {this.state.loadingType || this.state.loadingHardware || this.state.loadingGetEvents  ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : (
                    <>
                        <div className="event-container">
                            <div className='line-filds-events cont-inputs'>
                                <div>
                                    <Label for="nome">Nome:</Label>
                                    <input
                                        id="nome"
                                        disabled={this.state.loading}
                                        type="text"
                                        className='form-control input-change-color'
                                        placeholder="Pressão Pneumatica"
                                        autoComplete="off"
                                        value={this.state.eventMain.name}
                                        onChange={(i) => this.setState({ eventMain: { ...this.state.eventMain, name: i.target.value } })} />
                                </div>
                                <div>
                                    <Label for="codigo" >Código:</Label>
                                    <input
                                        id="codigo"
                                        disabled={this.state.loading}
                                        ref={this.codeInput}
                                        type="text"
                                        className='form-control input-change-color'
                                        placeholder="MEC_PRESSAO_01"
                                        onBlur={() => this.checkEventCode()}
                                        autoComplete="off"
                                        value={this.state.eventMain.code}
                                        onChange={(i) => this.setState({ eventMain: { ...this.state.eventMain, code: i.target.value } })}
                                    />
                                </div>
                                <div>
                                    <Label for="peso">Peso:</Label>
                                    <input
                                        id="peso"
                                        disabled={this.state.loading}
                                        type="text"
                                        className='form-control input-change-color'
                                        placeholder="0,25"
                                        autoComplete="off"
                                        value={this.state.eventMain.weight}
                                        onChange={(i) => this.setState({ eventMain: { ...this.state.eventMain, weight: i.target.value } })} />
                                </div>

                            </div>
                            <div className='line-filds-events mg-left'>
                                <div style={{ width: '220px' }}>
                                    <Label for="tipo">Tipo:</Label>
                                    <Select
                                        className='toolbar-select select-change-color'
                                        placeholder="Tipo"
                                        noOptionsMessage={e => this.noOptionsMessage(e, "eventType")}
                                        options={this.state.eventsType}
                                        closeMenuOnSelect={true}
                                        onChange={this.handleEventsType}
                                        isDisabled={this.state.loading}
                                        defaultInputValue={this.state.eventMain.eventType}
                                        inputId="tipo"
                                    />

                                </div>
                                <div style={{ width: '220px' }}>
                                    <Label for="hardware">Hardware:</Label>
                                    <Select
                                        className='toolbar-select select-change-color'
                                        placeholder="Hardware"
                                        noOptionsMessage={e => this.noOptionsMessage(e, "hardType")}
                                        options={this.state.hardsType}
                                        closeMenuOnSelect={true}
                                        onChange={this.handleHardsType}
                                        isDisabled={this.state.loading}
                                        defaultInputValue={this.state.eventMain.hardware}
                                        inputId="hardware"

                                    />
                                </div>

                                <div className="bool-events mg-bool">


                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            onChange={() => this.setState({ eventMain: { ...this.state.eventMain, active: !this.state.eventMain.active } })}
                                            checked={this.state.eventMain.active}
                                            disabled={this.state.loading}
                                            className="mg-input"
                                        />
                                        Ativo?
                                    </Label>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            onChange={() => this.setState({ eventMain: { ...this.state.eventMain, isGood: !this.state.eventMain.isGood } })}
                                            checked={this.state.eventMain.isGood}
                                            disabled={this.state.loading}
                                            className="mg-input"
                                        />
                                        Evento Bom?
                                    </Label>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            onChange={() => this.setState({ eventMain: { ...this.state.eventMain, isRuler: !this.state.eventMain.isRuler } })}
                                            checked={this.state.eventMain.isRuler}
                                            disabled={this.state.loading}
                                            className="mg-input"
                                        />
                                        É Faixa?
                                    </Label>
                                </div>


                            </div>

                        </div>
                        <TableEventsCode
                            save={this.saveEvent}
                            loading={this.state.loading}
                            list={this.state.eventMain.listHardwareCodes}
                            redirect={() => this.backPage('', false)} />
                    </>
                )}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        editEventData: state.toEditEvent,
        oldStateFilter: state.oldStateFilter
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setOldState: (data, name) => dispatch(setOldState(data, name)),
        editEvents: (data, oldFilter) => dispatch(editEvents(data, oldFilter))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewEvent);
